<template>
    <div>
        <div class="container__suggestion">
            <div class="card__suggestion">
                <div class="card__header__suggestion mb-4">
                    <svg width="30" height="30" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.5 4.57227C13.7478 4.57227 5 13.3201 5 24.0723C5 34.8245 13.7478 43.5723 24.5 43.5723C35.2522 43.5723 44 34.8245 44 24.0723C44 13.3201 35.2522 4.57227 24.5 4.57227ZM34.6484 17.537L22.0484 32.537C21.9102 32.7016 21.7382 32.8346 21.5441 32.9269C21.35 33.0193 21.1384 33.0689 20.9234 33.0723H20.8981C20.6879 33.0722 20.48 33.0279 20.288 32.9423C20.0959 32.8567 19.924 32.7317 19.7834 32.5754L14.3834 26.5754C14.2463 26.4299 14.1396 26.2585 14.0697 26.0713C13.9997 25.884 13.9679 25.6846 13.9761 25.4849C13.9843 25.2851 14.0323 25.089 14.1174 24.9081C14.2025 24.7272 14.3228 24.5651 14.4714 24.4314C14.62 24.2977 14.7939 24.195 14.9827 24.1294C15.1716 24.0638 15.3716 24.0366 15.5711 24.0495C15.7706 24.0623 15.9655 24.1149 16.1444 24.2041C16.3233 24.2934 16.4826 24.4175 16.6128 24.5691L20.8587 29.2866L32.3516 15.6076C32.6094 15.3095 32.9741 15.1249 33.3669 15.0936C33.7597 15.0623 34.1491 15.1868 34.4509 15.4403C34.7526 15.6938 34.9425 16.0558 34.9794 16.4481C35.0164 16.8405 34.8975 17.2316 34.6484 17.537Z" fill="#27AE60"/>
                    </svg>
                    <span class="cl_font">Merci pour votre commande</span>
                </div>
                <div class="card__body__suggestion">
                    <div class="item">
                        <div class="item__label">Date</div>
                        <div class="item__value">{{ info.date ? info.date : '' }}</div>
                    </div>
                    <div class="item">
                        <div class="item__label">Produit(s)</div>
                        <div class="item__value">
                            <span v-if="test(2)">Souscription à Assurance multirisque habitation “APEFA”, </span>
                            <span v-if="test(1)">Assurance Auto, </span>
                            <span v-if="test(3)">Assurance Voyage</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item__label">Sous-total (Net)</div>
                        <div class="item__value">{{ info.net ? info.net + ' Fcfa' : (info.total ? info.total + ' Fcfa' : '') }}</div>
                    </div>

                    <div class="item">
                        <div class="item__label">Total TTC</div>
                        <div class="item__value">{{ info.amount ? info.amount + ' Fcfa' : '' }}</div>
                    </div>
                    <div class="mt-3" v-if="userInfos.user.profile == 2 || userInfos.user.profile == 3">
                        <a :href="$routing('administration/subscriptions/me')" class="btn btn-primary">Suivre ma commande</a>
                    </div>
                    <div class="mt-3" v-if="userInfos.user.profile === 0">
                        <a :href="$routing('administration/subscriptions')" class="btn btn-primary">Suivre ma commande</a>
                    </div>
                    <div class="mt-3" v-if="info.uuid || (info.uuids && info.uuids.length > 0)">
                        <a :href="'/api/subscriptions/' + (info.uuid || info.uuids[0]) + '/invoice'" target="_blank" class="btn btn-outline-success">
                            <i class="fa fa-download"></i> Télécharger ma facture
                        </a>
                    </div>
                </div>
            </div>
            <div class="other__info">
                Autres produits d’assurances
            </div>
            <div class="other_product">
                <div class="mb-3 card__other">
                    <div class="card__other__icon">
                        <svg width="45" height="45" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.572266" width="72" height="72" rx="36" fill="#D39E0A"/>
                        <path d="M36.5002 19.9058C27.3068 19.9058 19.8335 27.3791 19.8335 36.5724C19.8335 45.7591 27.3068 53.2391 36.5002 53.2391C45.6868 53.2391 53.1668 45.7591 53.1668 36.5724C53.1668 27.3791 45.6868 19.9058 36.5002 19.9058ZM34.1068 49.9258C34.1002 49.9258 34.1002 49.9258 34.0935 49.9258C28.9002 48.9924 24.7402 45.1058 23.3935 40.0658C26.4068 39.9258 29.0935 40.7458 31.0535 42.4791C33.0002 44.2058 34.1535 46.7791 34.4602 49.9724C34.3468 49.9591 34.2268 49.9458 34.1068 49.9258ZM33.1268 38.0991C33.1268 36.2391 34.6402 34.7258 36.5002 34.7258C38.3602 34.7258 39.8735 36.2391 39.8735 38.0991C39.8735 39.9591 38.3602 41.4724 36.5002 41.4724C34.6402 41.4724 33.1268 39.9591 33.1268 38.0991ZM38.9002 49.9258C38.8935 49.9258 38.8935 49.9258 38.8868 49.9258C38.7735 49.9458 38.6535 49.9591 38.5335 49.9724C38.8402 46.7791 39.9935 44.1991 41.9402 42.4791C43.8935 40.7458 46.5868 39.9191 49.6002 40.0658C48.2535 45.1058 44.0935 48.9924 38.9002 49.9258ZM49.9468 34.7258C49.9468 34.7324 49.9402 34.7458 49.9402 34.7524C50.0002 35.2124 50.0402 35.6858 50.0602 36.1591C48.4202 36.0058 47.0535 35.3858 45.6202 34.7258C43.4202 33.7191 40.9202 32.5724 36.5202 32.5724C32.1202 32.5724 29.6068 33.7191 27.3935 34.7258C25.9535 35.3858 24.5802 36.0058 22.9402 36.1591C22.9602 35.6858 23.0002 35.2124 23.0602 34.7458C23.0602 34.7391 23.0535 34.7324 23.0535 34.7258C23.0535 34.6658 23.0735 34.6124 23.0868 34.5591C24.0602 28.0258 29.7002 22.9924 36.5002 22.9924C43.2935 22.9924 48.9202 28.0124 49.9068 34.5324C49.9268 34.5924 49.9468 34.6591 49.9468 34.7258Z" fill="white"/>
                        </svg>
                    </div>
                    <div class="card__other__content">
                        <h6 class="p__class">Assurance Auto</h6>
                        <p>
                            Couvrez les dommages matériels et / ou corporels que votre véhicule peut occasionner à autrui et à vous même
                        </p>
                    </div>
                    <div class="card__other__next">
                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5492 33.1481C12.8169 32.4159 12.8169 31.2287 13.5492 30.4964L23.4734 20.5723L13.5492 10.6481C12.8169 9.91586 12.8169 8.72868 13.5492 7.99644C14.2814 7.26421 15.4686 7.26421 16.2008 7.99644L27.4508 19.2464C28.1831 19.9787 28.1831 21.1659 27.4508 21.8981L16.2008 33.1481C15.4686 33.8803 14.2814 33.8803 13.5492 33.1481Z" fill="#D39E0A"/>
                        </svg>
                    </div>
                </div>
                <div class="mb-3 card__other">
                    <div class="card__other__icon">
                        <svg width="45" height="45" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.572266" width="72" height="72" rx="36" fill="#D39E0A"/>
                        <path d="M52.6204 21.2162C52.3583 20.8471 52.0188 20.5396 51.6256 20.3152C51.2325 20.0908 50.7951 19.9548 50.344 19.9168C49.8929 19.8787 49.4389 19.9396 49.0137 20.095C48.5885 20.2505 48.2024 20.4968 47.8821 20.8168L41.6833 27.0158L25.4818 22.2504C25.2412 22.1796 24.9859 22.1749 24.7429 22.2369C24.4998 22.2988 24.278 22.4252 24.1006 22.6026L22.3132 24.3898C22.1656 24.5373 22.053 24.7161 21.9837 24.9128C21.9143 25.1096 21.8899 25.3194 21.9122 25.5268C21.9346 25.7342 22.0031 25.934 22.1128 26.1115C22.2226 26.2889 22.3706 26.4395 22.5462 26.5522L34.4848 34.2141L33.3957 35.3033C32.4339 36.27 31.5593 37.3196 30.7819 38.44L22.5289 37.5596C22.3207 37.5374 22.1102 37.5621 21.9128 37.6319C21.7154 37.7017 21.5362 37.8147 21.3882 37.9628L20.2444 39.1064C20.0962 39.2546 19.983 39.4342 19.9133 39.6318C19.8436 39.8295 19.8191 40.0403 19.8416 40.2487C19.864 40.4571 19.9329 40.6579 20.0432 40.8362C20.1534 41.0144 20.3022 41.1658 20.4786 41.279L27.3862 45.7119L31.8258 52.6298C31.9382 52.805 32.0884 52.9527 32.2655 53.0622C32.4425 53.1717 32.6418 53.2401 32.8487 53.2624C33.0556 53.2847 33.2649 53.2604 33.4612 53.1912C33.6575 53.122 33.8358 53.0097 33.983 52.8625L35.1388 51.7066C35.2858 51.5596 35.398 51.3816 35.4672 51.1856C35.5365 50.9895 35.5609 50.7805 35.5389 50.5738L34.6582 42.3162C35.7786 41.5389 36.8282 40.6641 37.7948 39.7023L38.8839 38.6133L46.5382 50.5397C46.6518 50.7167 46.8036 50.866 46.9825 50.9767C47.1614 51.0873 47.3629 51.1564 47.572 51.179C47.7811 51.2016 47.9927 51.177 48.1911 51.107C48.3894 51.0371 48.5696 50.9236 48.7184 50.7748L50.4907 49.0024C50.6695 48.8236 50.7969 48.5998 50.8594 48.3547C50.9219 48.1097 50.9172 47.8523 50.8458 47.6096L46.0825 31.4149L52.1637 25.3335C53.2594 24.2377 53.5261 22.4736 52.6204 21.2162Z" fill="white"/>
                        </svg>
                    </div>
                    <div class="card__other__content">
                        <h6 class="p__class">Assurance Voyage</h6>
                        <p>
                            Contre la survenance d’un certain nombre d’évènements à l’occasion et au cours de son voyage hors du territoire togolais
                        </p>
                    </div>
                    <div class="card__other__next">
                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5492 33.1481C12.8169 32.4159 12.8169 31.2287 13.5492 30.4964L23.4734 20.5723L13.5492 10.6481C12.8169 9.91586 12.8169 8.72868 13.5492 7.99644C14.2814 7.26421 15.4686 7.26421 16.2008 7.99644L27.4508 19.2464C28.1831 19.9787 28.1831 21.1659 27.4508 21.8981L16.2008 33.1481C15.4686 33.8803 14.2814 33.8803 13.5492 33.1481Z" fill="#D39E0A"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="payment__info">
            <div class="payment__info--text">Moyens de paiement acceptés</div>
            <div class="payment__widget">
                <img :src="$assets('images/payment.png')" width="140" alt="payment">
            </div>
        </div>
        <div class="voyage__info">
            <div class="happy__young" :style="`background: url(${$assets('images/young.png')}) no-repeat center;background-size: cover;`"></div>
            <div class="hire__me">
                <div class="background__info">
                    <div class="svg__hire">
                        <svg width="188" height="188" viewBox="0 0 188 188" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z" fill="#E8EFFF"/>
                        </svg>
                    </div>
                    <div class="hire__me--text">Contactez-nous</div>
                    <div class="hire__me--description">
                        Si vous avez des questions ou rencontrez une difficulté, contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
                    </div>
                    <div class="hire__me--button">
                        <button class="btn btn-secondary">Parler à un expert</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        info: {},
        userInfos: {}
    }),
    mounted() {
        this.userInfos = JSON.parse(localStorage.getItem('auth'))
    },
    created() {
        const details = this.$storage.getItem('details')
        if (details){
            const element = JSON.parse(this.$storage.decryptString(details));
            if (typeof element === "object"){
                this.info = element;
            }
        }
    },
    methods:{
        test(el){
            if (this.info.products.includes(el)){
                return true;
            }else return false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .container__suggestion{
        margin: 20px 25% 20px 25%;
        .card__suggestion{
            background: #FFFFFF;
            border-radius: 4px;
            height: auto;
            padding: 24px;
        }
    }
    .card__header_suggestion span{
        font-weight: bold;
        font-size: 24px;
        color: #000000;
    }
    @media only screen and (max-width: 730px) {
        .container__suggestion{
            margin: 20px 5% 20px 5% !important;
        }
    }
    .cl_font{
        font-weight: bold;
        font-size: 16px;
    }
    .item{
        margin-top: 20px;
        display: grid;
        grid-template-columns: 200px 1fr;
        .item__label{
            color: #515469;
            font-weight: 600;
            font-size: 16px;
        }
        .item__value{
            color: #000000;
            font-weight: 600;
            font-size: 16px;
        }
    }

    .btn-primary {
    color: #fff;
    background-color: #002A85;
    border-color: #002A85;
}

.btn-primary:hover {
    color: #fff;
    background-color: #002A85;
    border-color: #002A85;
}

.btn-primary:focus, .btn-primary.focus {
    color: #fff;
    background-color: #002A85;
    border-color: #002A85;
    box-shadow: 0 0 0 0.2rem #002A85;
}

.btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #002A85;
    border-color: #002A85;
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #002A85;
    border-color: #002A85;
}

.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem #002A85;
}
.other__info{
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
}
.card__other{
    display: grid;
    grid-template-columns: 70px 2fr 70px;
    background: #FFFFFF;
    border-radius: 7px;
    padding: 20px;
    color: #5E5873;
    .card__other__next {
        align-self: center;
        justify-self: end;
        cursor: pointer;
    }
    .card__other__icon {
        align-self: center;
    }
}
.p__class{
    font-size: 18px;
    font-weight: 600;
    color: #000000;
}
.other_product{
    margin-bottom: 20px;
}
</style>
